<template>
  <component
    :is="isMobile ? TheNuxtLink : 'div'"
    v-bind="isMobile ? linkProps : {}"
    class="block h-full rounded bg-white p-3 shadow-normal shadow-gray-400 tablet:p-4 desktop:p-5"
  >
    <div>
      <h3 class="text-h4 mb-2 line-clamp-3">{{ title }}</h3>
      <span v-if="caption" class="mb-2 block text-xs text-gray-400">
        {{ caption }}
      </span>
    </div>
    <div class="w-full desktop:flex">
      <div class="mb-3 w-full desktop:mb-0 desktop:flex-1">
        <div
          class="w-full desktop:flex desktop:h-full desktop:flex-col desktop:justify-between desktop:pr-5"
        >
          <p v-if="description" class="line-clamp-4 text-sm text-gray-600">
            {{ description }}
          </p>
          <TheArrowLink v-if="!isMobile" :to="to" :title="buttonName">
            {{ buttonName }}
          </TheArrowLink>
        </div>
      </div>
      <div
        v-if="imageUrl"
        class="w-full desktop:w-[240px] desktop:basis-[240px]"
      >
        <figure
          class="relative block aspect-video w-full overflow-hidden rounded"
        >
          <img
            :src="imageUrl"
            :alt="title"
            loading="lazy"
            class="pointer-events-none absolute left-0 top-0 block h-full w-full object-cover"
          />
        </figure>
      </div>
    </div>
  </component>
</template>

<!-- eslint-disable @typescript-eslint/no-unused-vars -->
<script setup lang="ts">
  import type { RouteLocationRaw } from 'vue-router';

  import type { NuxtLinkProps } from '#app';

  interface IProps extends NuxtLinkProps {
    to?: RouteLocationRaw;
    title: string;
    caption?: string;
    description?: string;
    imageUrl?: string;
    buttonName: string;
  }

  const props = withDefaults(defineProps<IProps>(), {
    to: undefined,
    caption: '',
    description: '',
    imageUrl: '',
  });

  const TheNuxtLink = resolveComponent('TheNuxtLink');
  const { isMobile } = useScreen();

  const linkProps = computed((): NuxtLinkProps => {
    const { caption, description, imageUrl, buttonName, ...nuxtLinkProps } =
      props;

    return nuxtLinkProps;
  });
</script>
